module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-external-links","options":{"target":"_blank","rel":"nofollow noopener noreferrer"}},{"resolve":"gatsby-remark-images","options":{"maxWidth":1200,"quality":100,"showCaptions":true,"markdownCaptions":true}},{"resolve":"gatsby-remark-custom-blocks","options":{"blocks":{"colTwo":{"classes":"col2"}}}},{"resolve":"gatsby-remark-embedder","options":{}}],"remarkPlugins":[null]},
    },{
      plugin: require('../node_modules/gatsby-theme-dotdev/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
